import { render, staticRenderFns } from "./EmployeeBase.vue?vue&type=template&id=6db9fce9&"
import script from "./EmployeeBase.vue?vue&type=script&lang=js&"
export * from "./EmployeeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports